import Marquee from "react-fast-marquee";
import { Reveal } from "@/components/landing/Reveal";

export const PromiseSection = () => (
  <section className="relative overflow-hidden bg-ink2 py-16 lg:py-24" data-testid="promise-section">
    <Marquee speed={40} gradient={false} className="py-4">
      <span className="mx-8 font-display text-6xl font-bold uppercase tracking-tight text-surface sm:text-8xl">
        We Build Traders
      </span>
      <span className="mx-8 font-display text-6xl font-bold uppercase tracking-tight text-em1/25 sm:text-8xl">
        Not Tips
      </span>
      <span className="mx-8 font-display text-6xl font-bold uppercase tracking-tight text-surface sm:text-8xl">
        Face To Face
      </span>
      <span className="mx-8 font-display text-6xl font-bold uppercase tracking-tight text-gold/20 sm:text-8xl">
        Real Trading Floor
      </span>
    </Marquee>

    <div className="mx-auto max-w-4xl px-4 sm:px-8">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2rem] border border-em2/35 bg-surface p-8 text-center glow-emerald sm:p-14">
          <div className="pointer-events-none absolute left-1/2 top-0 h-40 w-96 -translate-x-1/2 rounded-full bg-em1/20 blur-[80px]" />
          <p className="relative z-10 text-xs font-bold uppercase tracking-[0.28em] text-gold">
            The BullsEdge Promise
          </p>
          <h2 className="relative z-10 mt-5 font-display text-5xl font-bold uppercase leading-[0.95] text-offwhite sm:text-7xl">
            We Don't Sell Tips.
            <br />
            <span className="text-em2">We Build Traders.</span>
          </h2>
          <p className="relative z-10 mx-auto mt-5 max-w-2xl text-base leading-relaxed text-mutedgreen">
            We're an academy run by traders who've been doing this for 10+ years.
            We don't send signals or promise quick money — we teach you a skill
            you'll use for life, face to face, on a real trading floor with mentors
            who trade every day. And you're never really alone — even outside class,
            our traders community is there to talk ideas through with you.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
